import axiosClient, { axiosClientBase } from "./axiosClient";

const inquiryApi = {
  getInquiryData: (payload: any) => {
    return axiosClientBase.get(`/external/getOnBoarding`, { params: payload });
  },

  updateInquiryStatus: (payload: { _id: string; status: string }) => {
    return axiosClient.post(`onboarding/onboardingUpdate`, payload);
  },
};

export default inquiryApi;
